module.exports = __webpack_public_path__ + "img/lsl1011jp01.3bf01bf8.jpg";